'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import EnterpriseSoftwareDevelopment from '@/components/technologies/enterprise-software-development';
import EnterpriseSoftwareServies from '@/components/technologies/enterprise-provide-services';
import TechnologyFaq from '@/components/technologies/technology-faq';
import EnterpriseSoftwareFAQ from '@/components/faqs/enterprise-software-faq';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Enhance your business efficiency and agility with our custom enterprise software development services. Automate your manual tasks, streamline workflows, and centralize data to improve visibility and collaboration."
                alt="Enterprise software Development"
                title="Enterprise software Development"
                width={1090}
                height={604}
                path={'enterprise-software-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Enterprise Software <div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="Enterprise Software Development" />
            <EnterpriseSoftwareDevelopment title="Accelerate Innovation and Efficiency With Our Enterprise Software Development"></EnterpriseSoftwareDevelopment>
            <EnterpriseSoftwareServies />
            <HireProcess
                bg="bg-enterprise-software"
                pageTitle="Hire Enterprise Software Development Company To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Enterprise Software Solutions."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Enterprise Software Development?" />
            <ModelsOfWorking
                title="Engagement Models to Hire the Best Enterprise Software Developers"
                desc="Select from different engagement models to hire Enterprise Software Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On Enterprise Software Development" bg="bg-enterprise-software">
                <EnterpriseSoftwareFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
